
global.facebookApp=false;
global.facebookAppInit=false;
global.FB=null;

global.startFacebookApp = function () {
	facebookApp=true;
	console.log('init facebookapp')
	window.fbAsyncInit = function() {
	    FB.init({
	      appId      : otuApp.appState.facebookAppId,
	      xfbml      : true,
	      version    : 'v2.5',
	      cookie	 :true
	    });

	    FB.getLoginStatus(function(response) {
				global.facebookAppInit=true;

	    	  if (response.status === 'connected') {
	    	    // the user is logged in and has authenticated your
	    	    // app, and response.authResponse supplies
	    	    // the user's ID, a valid access token, a signed
	    	    // request, and the time the access token 
	    	    // and signed request each expire
	    		console.log('Facebook App Response: connected') 
	    		//console.log('Access Token:')
	    		//console.log(response.authResponse.accessToken);
	    		 
	    	    var uid = response.authResponse.userID;
	    	    var accessToken = response.authResponse.accessToken;
	    	  } else if (response.status === 'not_authorized') {
	    	    // the user is logged in to Facebook, 
	    	    // but has not authenticated your app
		    		console.log('Facebook App Response: App not authorized')  
		    		console.log('asking the user to login')
		    		//FB.login(function(response){
		    			  // Handle the response object, like in statusChangeCallback() in our demo
		    			  // code.
		    		//		console.log('login response');
		    		//		console.log(response);
		    		//	});
	    	  } else {
		    		console.log('Facebook App Response: User not logged into facebook');
	    	  }
	    });
	    
		  FB.Event.subscribe('edge.create', function(response) {
			  console.log('something created on facebook');
			  console.log(response);
		  });
	  };
	
	  (function(d, s, id){
	     var js, fjs = d.getElementsByTagName(s)[0];
	     if (d.getElementById(id)) {return;}
	     js = d.createElement(s); js.id = id;
	     js.src = "//connect.facebook.net/en_US/sdk.js";
	     fjs.parentNode.insertBefore(js, fjs);
	   }(document, 'script', 'facebook-jssdk'));
}	  